import axios from 'axios';
import VueI18n from 'vue-i18n';

axios.interceptors.request.use(
    config => {
        config.headers['Accept-Language'] = 'de';
        return config;
    },
    function(error) {
        // Do something with request error
        return Promise.reject(error);
    }
);
